module.exports = __webpack_public_path__ + "img/inspiring_background.8199437.webp";